export default __webpack_public_path__ + "static/media/whatsapp_QR.11264f7d.png";